import { Injectable } from '@angular/core';
import { ApiHttpService } from '../Service/api.http.service';
import { APIEndPoints } from '../utils/api-endpoint';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ProfessionalService {
  isProfessionalInvite;
  constructor(
    private readonly _apiService: ApiHttpService,
    private readonly http: HttpClient,
  ) {}

  addProfessionalPlanner(data: any) {
    return this._apiService.post(
      APIEndPoints.Professional + '/AddFCProfessional',
      data,
    );
  }

  getFinancialPlanner() {
    return this._apiService.get(
      APIEndPoints.Professional + '/GetFcAdvisorTypes',
    );
  }

  getProfessionalInfo() {
    return this._apiService.get(
      APIEndPoints.Professional + '/GetFCProfessionalInfo',
    );
  }
  getPendingInvitesByProfessional() {
    return this._apiService.get(
      APIEndPoints.Professional + '/GetPendingInvitesByProfessional',
    );
  }
  inviteCustomer(customer: any): Observable<any> {
    return this._apiService.post(
      APIEndPoints.Professional + '/InviteCustomer',
      customer,
    );
  }
  uploadFile(file: File, formdata: any): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('value', JSON.stringify(formdata)); // Send associated data
    return this._apiService.post(
      APIEndPoints.Professional + '/Upload',
      formData,
    );
  }
  login(formdata: any): Observable<any> {
    return this.http.post(
      'https://dev-familycentral.us.auth0.com/dbconnections/signup',
      formdata,
    );
  }

  getCustomerInfo(): Observable<any> {
    return this._apiService.get(APIEndPoints.Professional + '/Customers');
  }

  deleteCustomer(id: string): Observable<any> {
    return this._apiService.delete(
      APIEndPoints.Professional + '/Customer/${id}',
    );
  }
  uploadCustomerFile(file: File, formdata: any): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('value', JSON.stringify(formdata)); // Send associated data
    return this._apiService.post(
      APIEndPoints.Professional + '/CustomerWithFile',
      formData,
    );
  }

  editCustomer(id: any, data: any) {
    return this._apiService.put(
      APIEndPoints.Professional + `/Customer/${id}`,
      data,
    );
  }

  addCustomer(customer: any): Observable<any> {
    return this._apiService.post(
      APIEndPoints.Professional + `/Customer`,
      customer,
    );
  }
  acceptInvitation(data: any) {
    return this._apiService
      .post(`${APIEndPoints.Professional}/AcceptInvite`, data)
      .pipe();
  }
  isEmailExists(email: any): Observable<any> {
    return this._apiService.post(
      APIEndPoints.Professional + '/TPAEmailValidations',
      email,
    );
  }
}
